// src/features/insight-v2-shared/components/PropertyState.tsx
//
// What a v2 screen shows in place of its data while it has no property to
// read: the list is loading, it failed to load (with a retry), or none of the
// user's hotels has check-in data (no access to any, or only hotels that send
// none) — stated as such, never replaced by the v1 hotels.
import React from 'react';
import { DomainDisabledRounded as NoPropertyIcon } from '@mui/icons-material';
import { useTranslate } from 'react-admin';
import { EmptyState } from '@/components/common/EmptyState';
import { FetchErrorBanner } from '@/components/common/FetchErrorBanner';
import { LoadingState } from '@/components/common/LoadingState';
import type { V2PropertySelection } from '@/hooks/useV2PropertySelection';

interface PropertyStateProps {
  selection: V2PropertySelection;
}

export const PropertyState: React.FC<PropertyStateProps> = ({ selection }) => {
  const translate = useTranslate();

  if (selection.status === 'error') return <FetchErrorBanner onRetry={selection.retry} />;
  if (selection.status === 'empty') {
    return (
      <EmptyState
        icon={<NoPropertyIcon />}
        message={translate('resources.insightV2.noCheckinData.message')}
        description={translate('resources.insightV2.noCheckinData.hint')}
        minHeight={240}
      />
    );
  }
  return <LoadingState variant="circular" minHeight={240} />;
};

export default PropertyState;
